import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const CorpoModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-width: 480px;
  max-width: 560px;

  p {
    color: ${Cores.CINZA_2};
    font-size: 14px;
    margin-bottom: 16px;
  }
`

export const TituloModal = styled.h5`
  margin-bottom: 12px;
  color: ${Cores.PRIMARIA_1};
`

export const CampoAluno = styled.div`
  margin-bottom: 16px;
`

export const AvisoBloqueio = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 6px;
  background-color: ${Cores.PERIGO_ERRO_FUNDO};
  color: ${Cores.PERIGO_ERRO_ESCURO};
  font-size: 13px;
`

// Ocupa o mesmo lugar do AvisoBloqueio enquanto a elegibilidade é consultada: sem isso, o único
// sinal de que algo está acontecendo é o botão desabilitado, que parece a tela travada.
export const AvisoVerificando = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 6px;
  background-color: ${Cores.CINZA_3_MAIS_CLARO};
  color: ${Cores.CINZA_2};
  font-size: 13px;

  & > i {
    display: flex;
    color: ${Cores.SECUNDARIA_2_ESCURO};

    & svg {
      width: 16px;
      height: 16px;
    }
  }
`

export const AcoesModal = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`
